import React from 'react';
import {PhoneHQAvatar} from "ch3-ui-lib";
import {useAuthenticatedMedia} from "../../hooks/useAuthenticatedMedia.ts";

/**
 * Member avatars live behind authenticated media, so an mxc URL has to be
 * resolved rather than handed straight to an <img>; initials stay as the
 * fallback while it loads and if it fails outright.
 */
export const MatrixAvatar: React.FC<{
    name: string;
    mxcUrl?: string | null;
    size: React.ComponentProps<typeof PhoneHQAvatar>['size'];
    className?: string;
}> = ({name, mxcUrl, size, className}) => {
    const {blobUrl} = useAuthenticatedMedia(mxcUrl || '');

    return <PhoneHQAvatar size={size} name={name} src={blobUrl || undefined} className={className}/>;
};
